export const BASE_URL = "https://www.w3era.com/api/";
